// src/utils/countries.ts
import countries from '@/data/countries.json'

interface Country {
  name: string
  code: string
  emoji: string
  unicode: string
  image: string
}

/**
 * Get all countries
 * @returns {Country[]} - The list of countries
 */
export function getAllCountries(): Country[] {
  return countries
}

/**
 * Get a country by its ISO 3166-1 alpha-2 code
 * @param isoCode - The ISO 3166-1 alpha-2 code of the country
 * @returns {Country | null} - The country or null if not found
 */
export function getCountryByCode(isoCode: string): Country | null {
  return countries.find(country => country.code === isoCode) || null
}
